import React, { JSX, useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import BulkActionControl from '@Components/BulkAction/BulkActionControl'
import { isOverclaimHelper } from '@App/helpers/is-overclaim-helper'

interface OverclaimBulkActionControlProps {
    isSubmitDisabled?: boolean
    submitButtonText?: string
    submitButtonOnClick?: () => void
    instructions?: string
    bulkSelectionCountText: string
    displayConfirmationPopup?: boolean
    confirmationPopup?: JSX.Element
}
const OverclaimBulkActionControl = (props: OverclaimBulkActionControlProps) => {
    const { overclaimSearchStore, overclaimSearchBulkActionStore } = useContext(StoresContext)
    const {
        isSubmitDisabled,
        submitButtonText,
        submitButtonOnClick,
        instructions,
        bulkSelectionCountText,
        displayConfirmationPopup,
        confirmationPopup,
    } = props

    const worksOnPage = overclaimSearchStore.worksRightsHolder?.works ?? []
    const enabledWorks = worksOnPage.filter((work) => isOverclaimHelper(work) && !work.relinquished)

    return (
        <BulkActionControl
            enabledWorks={enabledWorks}
            idList={enabledWorks
                .map((workModel) => workModel.overclaimHeaderId)
                .filter((overclaimHeaderId): overclaimHeaderId is number => overclaimHeaderId !== undefined)}
            bulkSelectionCountText={bulkSelectionCountText}
            totalSelectionCount={overclaimSearchStore.worksRightsHolder?.count ?? 0}
            bulkActionStore={overclaimSearchBulkActionStore}
            pagination={overclaimSearchStore.pagination}
            isSubmitDisabled={isSubmitDisabled}
            submitButtonText={submitButtonText}
            submitButtonOnClick={submitButtonOnClick}
            instructions={instructions}
            displayConfirmationPopup={displayConfirmationPopup}
            confirmationPopup={confirmationPopup}
        />
    )
}
export default observer(OverclaimBulkActionControl)
